import { useEffect, useState } from "react";
import api, { API } from "../../lib/api";
import { PageHeader, EmptyState } from "../../components/app/Common";
import { Button } from "../../components/ui/button";
import { Badge } from "../../components/ui/badge";
import { fmtDate } from "../../lib/utils";
import { Download, FileSpreadsheet } from "lucide-react";

const STATUS_STYLE = {
  Draft:         "bg-muted text-muted-foreground border-border",
  "In Progress": "bg-blue-500/10 text-blue-500 border-blue-500/40",
  "In Review":   "bg-[hsl(var(--status-hold))/0.1] text-[hsl(var(--status-hold))] border-[hsl(var(--status-hold))/0.4]",
  Closed:        "bg-[hsl(var(--status-pass))/0.1] text-[hsl(var(--status-pass))] border-[hsl(var(--status-pass))/0.4]",
};

export default function AdminITPRegister() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/itp/inspections").then(({ data }) => setRows(data));
  }, []);

  const download = async () => {
    const token = localStorage.getItem("ss_token");
    const res = await fetch(`${API}/itp/register.csv`, { headers: { Authorization: `Bearer ${token}` } });
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = "itp_register.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="p-6 md:p-10 max-w-7xl mx-auto">
      <PageHeader
        title="ITP Register"
        subtitle="Every inspection instance across the company."
        action={
          <Button variant="outline" className="rounded-sm border-border" onClick={download} data-testid="itp-reg-export">
            <Download className="h-4 w-4 mr-1.5" /> Export CSV
          </Button>
        }
      />
      {rows.length === 0 ? (
        <EmptyState title="No inspections" body="Clone an ITP template to a project to create your first inspection." />
      ) : (
        <div className="border border-border rounded-sm overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-muted/40 overline text-left">
              <tr>
                <Th>Template</Th><Th>Rev</Th><Th>Spec</Th><Th>Project</Th><Th>Location</Th><Th>Status</Th><Th>Created</Th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} className="border-t border-border hover:bg-accent/30" data-testid={`itp-reg-${r.id}`}>
                  <Td><FileSpreadsheet className="inline h-4 w-4 mr-2 text-primary" />{r.template_snapshot?.title}</Td>
                  <Td mono>{r.template_snapshot?.revision}</Td>
                  <Td mono>{r.template_snapshot?.spec_section || "—"}</Td>
                  <Td>{r.project_name}</Td>
                  <Td mono>{r.location_details || "—"}</Td>
                  <Td>
                    <Badge variant="outline" className={`rounded-sm font-mono uppercase tracking-widest text-[10px] ${STATUS_STYLE[r.status] || ""}`}>
                      {r.status}
                    </Badge>
                  </Td>
                  <Td mono>{fmtDate(r.created_at)}</Td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

const Th = ({ children }) => <th className="px-4 py-2 font-mono text-[10px] tracking-widest">{children}</th>;
const Td = ({ children, mono }) => <td className={`px-4 py-3 ${mono ? "font-mono text-xs" : ""}`}>{children}</td>;
